import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { Pagination } from '../../features/Pagination';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const CurrenciesPage = () => {
  const [currencies, setCurrencies] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const location = useLocation();

  const getData = async (count = 10, offset = 0) => {
    try {
      const response = await apiRequests.currencies.get(count, offset);
      setCurrencies(response);
    } catch (e) {
      console.log('currencies error: ', e);
    }
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.currencies.getFiltered(searchValue).then((res) => setCurrencies(res));
    }
  };

  useEffect(() => {
    // getData()
  }, []);

  const handleDelete = (id) => {
    apiRequests.currencies.delete(id).then(() =>
      setCurrencies((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск валют..."
        createLink={`${location.pathname}/create`}
      />

      <div className="mb-3">
        {currencies.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          currencies.items?.map((item) => (
            <EntityCard
              key={item.id}
              title={`${item.title} [ ${item.symbol} ]`}
              editLink={`${location.pathname}/${item.id}`}
              localizationLink={`${location.pathname}/${item.id}/localization`}
              onDelete={!item.isDefault ? () => handleDelete(item.id) : null}
            />
          ))
        )}
      </div>

      <Pagination
        count={currencies.totalCount}
        itemsPerPage={10}
        onChange={(page) => getData(10, page * 10)}
      />
    </>
  );
};

export default CurrenciesPage;
